// 不作为Main组件的子页面展示的页面单独写，如下
export const loginRouter = {
    path: '/login',
    name: 'login',
    meta: {
        title: '登录 - X-Boot前后端分离开发平台 '
    },
    component: () => import('@/views/login.vue')
};

export const registRouter = {
    path: '/regist',
    name: 'regist',
    meta: {
        title: '注册 - X-Boot前后端分离开发平台'
    },
    component: () => import('@/views/regist.vue')
};

export const registResult = {
    path: '/regist-result',
    name: 'regist-result',
    meta: {
        title: '注册结果 - X-Boot前后端分离开发平台'
    },
    component: () => import('@/views/regist-result.vue')
};

export const thirdLogin = {
    path: '/thirdLogin/:id',
    name: 'thirdLogin',
    meta: {
        title: '第三方登录 - X-Boot前后端分离开发平台 '
    },
    component: () => import('@/views/thirdLogin.vue')
};
export const page404 = {
    path: '/404',
    name: 'error-404',
    meta: {
        title: '404-页面不存在'
    },
    component: () => import('@/views/error-page/404.vue')
};

export const page403 = {
    path: '/403',
    meta: {
        title: '403-权限不足'
    },
    name: 'error-403',
    component: () => import('@/views/error-page/403.vue')
};

export const page500 = {
    path: '/500',
    meta: {
        title: '500-服务端错误'
    },
    name: 'error-500',
    component: () => import('@/views/error-page/500.vue')
};

export const locking = {
    path: '/locking',
    name: 'locking',
    component: () => import('@/views/main-components/lockscreen/components/locking-page.vue')
};

//咨询列表
export const consultationList = {
    path: '/consultation-list',
    name: 'consultationList',
    component: () => import('@/views/vipClip/consultation/consultation-list.vue')
};
//咨询详情
export const consultationInfo = {
    path: '/consultation-info/:id.html',
    name: 'consultationInfo',
    component: () => import('@/views/vipClip/consultation/consultation-info.vue')
};
//在线解答详情
export const onlineAnswers = {
    path: '/online-answers/:id.html',
    name: 'onlineAnswers',
    component: () => import('@/views/vipClip/consultation/online-answers.vue')
};
export const searchQuestion = {
    path: '/wenda.html',
    name: 'searchQuestion',
    component: () => import('@/views/vipClip/search-question/search-question.vue')
};
// 版权存证
export const applyCert = {
    path: '/apply-cert',
    name: 'applyCert',
    component: () => import('@/views/vipClip/copyrightEvidence/apply-cert.vue')
}
//存证列表
export const certList = {
    path: '/cert-list',
    name: 'certList',
    component: () => import('@/views/vipClip/copyrightEvidence/cert-list.vue')
};
//存证详情
export const certInfo = {
    path: '/cert-info',
    name: 'certInfo',
    component: () => import('@/views/vipClip/copyrightEvidence/cert-info.vue')
};
//存证介绍
export const copyrightEvidence = {
    path: '/cunzheng.html',
    name: 'copyrightEvidence',
    component: () => import('@/views/vipClip/copyrightEvidence/copyrightEvidence.vue')
};
//取证列表
export const evidenceList = {
    path: '/evidence-list',
    name: 'evidenceList',
    component: () => import('@/views/vipClip/evidence/evidence-list.vue')
};
//取证详情
export const evidenceInfo = {
    path: '/evidence-info',
    name: 'evidenceInfo',
    component: () => import('@/views/vipClip/evidence/evidence-info.vue')
};
//取证介绍
export const evidence = {
    path: '/evidence',
    name: 'evidence',
    component: () => import('@/views/vipClip/evidence/evidence.vue')
};
//取证网页
export const evidenceWeb = {
    path: '/evidenceWeb',
    name: 'evidenceWeb',
    component: () => import('@/views/vipClip/evidence/evidence-web.vue')
};
//版权监测
export const monitor = {
    path: '/monitor',
    name: 'monitor',
    component: () => import('@/views/vipClip/monitor/monitor')
};
//版权保险
export const insurance = {
    path: '/insurance',
    name: 'insurance',
    component: () => import('@/views/vipClip/insurance/insurance')
};
//会员开通
export const openVip = {
    path: '/openVip',
    name: 'openVip',
    component: () => import('@/views/vipClip/coupon/openVipStepz')
};
//会员我的订单去开通
export const orderPay = {
    path: '/orderPay',
    name: 'orderPay',
    component: () => import('@/views/vipClip/coupon/orderPay')
};
//版权监测介绍
export const monitorIntroduce = {
    path: '/jiance.html',
    name: 'monitorIntroduce',
    component: () => import('@/views/vipClip/monitor/monitor-introduce.vue')
};
//版权监测监测中
export const monitoring = {
    path: '/monitoring',
    name: 'monitoring',
    component: () => import('@/views/vipClip/monitor/monitoring.vue')
};
//版权监测监测详情
export const monitorDetails = {
    path: '/monitorDetails',
    name: 'monitorDetails',
    component: () => import('@/views/vipClip/monitor/monitorDetails.vue')
};

//关于我们
export const aboutUs = {
    path: '/guanyuwomen.html',
    name: 'aboutUs',
    component: () => import('@/views/vipClip/search-question/aboutUs.vue')
};

//版权登记
export const copyrightRegistration = {
    path: '/copyrightRegistration',
    name: 'copyrightRegistration',
    component: () => import('@/views/vipClip/copyrightRegistration/copyrightRegistration.vue')
};
export const copyrightRegistrationBHBJ = {
    path: '/copyrightRegistrationBHBJ',
    name: 'copyrightRegistrationBHBJ',
    component: () => import('@/views/vipClip/copyrightRegistration/copyrightRegistrationBHBJ.vue')
};

//版权预登记
export const copyrightRegistrationYuDengji = {
    path: '/copyrightRegistrationYuDengji',
    name: 'copyrightRegistrationYuDengji',
    component: () => import('@/views/vipClip/copyrightRegistration/copyrightRegistrationYuDengji.vue')
};

//版权登记活动
export const copyrightRegistrationActivity = {
    path: '/copyrightRegistrationActivity',
    name: 'copyrightRegistrationActivity',
    component: () => import('@/views/vipClip/copyrightRegistration/copyrightRegistrationActivity.vue')
};

//版权登记活动
// export const copyrightRegistrationSearch = {
//     path: '/banquanchaxun.html',
//     name: 'copyrightRegistrationSearch',
//     component: () => import('@/views/vipClip/copyrightRegistration/copyrightRegistrationSearch.vue')
// };

//版权登记列表
export const copyrightRegList = {
    path: '/copyrightRegList',
    name: 'copyrightRegList',
    component: () => import('@/views/vipClip/copyrightRegistration/copyrightRegList.vue')
};

//版权登记证书
export const copyrightCert = {
    path: '/copyrightCert',
    name: 'copyrightCert',
    component: () => import('@/views/vipClip/copyrightRegistration/copyrightCert.vue')
};

//版权登记详情
export const copyrightDetails = {
    path: '/copyrightDetails',
    name: 'copyrightDetails',
    component: () => import('@/views/vipClip/copyrightRegistration/copyrightDetails.vue')
};

//版权登记提交成功
export const copyrightSuccess = {
    path: '/copyrightSuccess',
    name: 'copyrightSuccess',
    component: () => import('@/views/vipClip/copyrightRegistration/copyrightSuccess.vue')
};

//去登记
// export const copyrightLogin = {
//     path: '/copyrightLogin',
//     name: 'copyrightLogin',
//     component: () => import('@/views/vipClip/copyrightRegistration/copyrightLogin.vue')
// };

//原创核验
export const contentListOriginal = {
    path: '/index/original_verification/:type/:id',
    name: 'contentListOriginal',
    component: () => import('@/views/vipClip/verificationOriginal/contentListOriginal.vue')
};
//核验
export const creationVerification = {
    path: '/index/creation_verification/:type/:id',
    name: 'creationVerification',
    component: () => import('@/views/vipClip/verification/contentList.vue')
};

//港安 核验中心Verification center
export const ganAnVerificationCenter = {
    path: '/index/ganAnVerificationCenter/:type/:id',
    name: 'ganAnVerificationCenter',
    component: () => import('@/views/vipClip/verification/gananContentList.vue')
};

//核验中心Verification center
export const verificationCenter = {
    path: '/index/verificationCenter',
    name: 'verificationCenter',
    component: () => import('@/views/vipClip/verification/verificationCenter.vue')
};


//核验-1200px核验码校验
export const verificationCode = {
    path: '/index/verification_code/:type/:id',
    name: 'verificationCode',
    component: () => import('@/views/vipClip/verification/verificationCode.vue')
};
//统一核验页面
export const verificationPublic = {
    path: '/index/common_verification/:type/:id',
    name: 'verificationPublic',
    component: () => import('@/views/vipClip/verification/verificationPublic.vue')
};
//存证核验中转页面
export const certVerify = {
    path: '/index/exchange/detail/:type/:id',
    name: 'certVerify',
    component: () => import('@/views/vipClip/copyrightEvidence/cert-verify.vue')
};

//DCI介绍页
export const dciIntroduce = {
    path: '/dciIntroduce',
    name: 'dciIntroduce',
    component: () => import('@/views/vipClip/firstPage/dciPage.vue')
};


//取证宝活动
export const evdenceActivity = {
    path: '/evidenceActivity',
    name: 'evdenceActivtiy',
    component: () => import('@/views/vipClip/firstPage/components/banner/evdenceActivtiy.vue')
};

//邀请好友中转页
export const invitePage = {
    path: '/invitePage',
    name: 'invitePage',
    component: () => import('@/views/vipClip/user/more/invitePage.vue')
};

//侵权取证详情-渠道
export const tortInfo = {
    path: '/tort-info/:type/:id',
    name: 'tortInfo',
    component: () => import('@/views/vipClip/evidence/tort-info.vue')
};
//定制订单
export const madeOrder = {
    path: '/registerVipConfig/singleUse/:code',
    // path: '/madeOrder',
    name: 'madeOrder',
    component: () => import('@/views/vipClip/vip/madeOrder.vue')
};

//侵权取证详情-渠道
export const channelCooperation = {
    path: '/fangan.html',
    name: 'channelCooperation',
    component: () => import('@/views/vipClip/channelCooperation/channelCooperation.vue')
};

// 首页vip的静态页面
export const vipOne = {path: '/vipPersonal', name: 'vipone', component: () => import('@/views/vipClip/vip/vipone.vue')};
export const vipTwo = {
    path: '/vipEnterprise',
    name: 'viptwo',
    component: () => import('@/views/vipClip/vip/viptwo.vue')
};
export const vipIntroduce = {
    path: '/huiyuan.html',
    name: 'vipIntroduce',
    component: () => import('@/views/vipClip/vip/vipIntroduce.vue')
};
//短视频详情
export const videoDetail = {
    path: '/videoDetail',
    name: 'videoDetail',
    component: () => import('@/views/vipClip/video/videoDetail.vue')
};




// 首页活动中心
export const activity = {path: '/huodong.html', name: 'activity', component: () => import('@/views/activity/activity.vue')};
/*// 首页活动中心详情页
export const activityDetail = {path: '/activity_detail', name: 'activity_detail', component: () => import('@/views/activity/activity_detil.vue')};

*/

// 春节红包优惠活动
// export const springFestival = {path: '/huodong/chunjie.html', name: 'springFestival', component: () => import('@/views/vipClip/huodong/springFestival.vue')};

// 知识产权日活动
// export const zhishichanquanri = {path: '/huodong/zhishichanquanri.html', name: 'zhishichanquanri', component: () => import('@/views/vipClip/huodong/zhishichanquanri.vue')};

// //答题
// export const answer = {path: '/huodong/answer.html', name: 'answer', component: () => import('@/views/vipClip/huodong/answer.vue')};
// export const answerQust = {path: '/huodong/answerQust.html', name: 'answerQust', component: () => import('@/views/vipClip/huodong/timu.vue')};
// export const answerQustion = {path: '/huodong/answerQustion.html', name: 'answerQust', component: () => import('@/views/vipClip/huodong/answerqustion.vue')};
export const vipSeven = {
    path: '/shiyong.html',
    name: 'vipseven',
    component: () => import('@/views/vipClip/vip/vipseven.vue')
};
export const lawContract = {
    path: '/fuwu/hetong.html',
    name: 'lawContract',
    component: () => import('@/views/vipClip/vip/lawContract.vue')
};
export const lawInfringing = {
    path: '/fuwu/qinquan.html',
    name: 'lawInfringing',
    component: () => import('@/views/vipClip/vip/lawInfringing.vue')
};
export const lawIssue = {
    path: '/fuwu/lvshihan.html',
    name: 'lawIssue',
    component: () => import('@/views/vipClip/vip/lawIssue.vue')
};
export const lawJudgement = {
    path: '/fuwu/weiquan.html',
    name: 'lawJudgement',
    component: () => import('@/views/vipClip/vip/lawJudgement.vue')
};
export const lawService = {
    path: '/fuwu.html',
    name: 'lawService',
    component: () => import('@/views/vipClip/vip/lawService.vue')
};
export const lawTelephone = {
    path: '/fuwu/dianhua.html',
    name: 'lawTelephone',
    component: () => import('@/views/vipClip/vip/lawTelephone.vue')
};
export const notarizationDetails = {
    path: '/notarizationDetails',
    name: 'notarizationDetails',
    component: () => import('@/views/vipClip/notarization/notarizationDetails.vue')
};
// export const threeSyndromesActivity = {
//     path: '/threeSyndromesActivity',
//     name: 'threeSyndromesActivity',
//     component: () => import('@/views/vipClip/threeSyndromesActivity/threeSyndromesActivity.vue')
// };
export const partnershipPlan = {
    path: '/chengshihehuoren.html',
    name: 'partnershipPlan',
    component: () => import('@/views/vipClip/partnershipPlan/partnershipPlan.vue')
};

// export const doubleTwelve = {
//     path: '/1212.html',
//     name: 'doubleTwelve',
//     component: () => import('@/views/vipClip/activity/doubleTwelve.vue')
// };

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
export const otherRouter = {
    path: '/',
    name: 'otherRouter',
    //redirect: '/home',
    component: () => import('@/views/Main.vue'),
    children: [
        // 2021-11-9
        {
            path: '/',
            title: {i18n: 'home'},
            name: 'ganan_home',
            component: () => import('@/viewsGangAn/home/index.vue')
        },
        {
            path: '/gananLogin',
            title: '登录',
            name: 'ganan_login',
            component: () => import('@/viewsGangAn/login/index.vue')
        },
        {
            path: '/gananRegistered',
            title: '注册',
            name: 'ganan_registered',
            component: () => import('@/viewsGangAn/login/registered.vue')
        },
        {
            path: '/gananFindPassword',
            title: '找回密码',
            name: 'ganan_findPassword',
            component: () => import('@/viewsGangAn/login/findPassword.vue')
        },
        {
            path: '/gananFindAccount',
            title: '找回账号',
            name: 'ganan_findAccount',
            component: () => import('@/viewsGangAn/login/findAccount.vue')
        },
        {
            path: '/gananElectronic',
            title: '电子存证',
            name: 'ganan_electronic',
            component: () => import('@/viewsGangAn/copyrightServices/electronic/index.vue')
        },
        {
            path: '/gananCertificate',
            title: '电子存证',
            name: 'ganan_certificate',
            component: () => import('@/viewsGangAn/copyrightServices/electronic/certificate.vue')
        },
        {
            path: '/gananPreRegistration',
            title: '版权区块链存证',
            name: 'ganan_preRegistration',
            component: () => import('@/viewsGangAn/copyrightServices/preRegistration/index.vue')
        },
        {
            path: '/gananCopyrightRegistration',
            title: '版权登记',
            name: 'ganan_copyrightRegistration',
            component: () => import('@/viewsGangAn/copyrightServices/copyrightRegistration/index.vue')
        },
        {
            path: '/gananSoftwareCopyright',
            title: '软件著作权登记',
            name: 'ganan_softwareCopyright',
            component: () => import('@/viewsGangAn/copyrightServices/softwareCopyright/index.vue')
        },
        {
            path: '/gananSoftwareCopyrightUp',
            title: '软件著作权登记',
            name: 'ganan_softwareCopyrightUp',
            component: () => import('@/viewsGangAn/copyrightServices/softwareCopyright/softwareCopyrightUp.vue')
        },
        {
            path: '/gananWebForensics',
            title: '网页取证',
            name: 'ganan_webForensics',
            component: () => import('@/viewsGangAn/copyrightServices/webForensics/index.vue')
        },
        {
            path: '/gananWebForensicsUp',
            title: '网页取证',
            name: 'ganan_webForensicsUp',
            component: () => import('@/viewsGangAn/copyrightServices/webForensics/webForensicsUp.vue')
        },
        {
            path: '/gananCopyrightMonitoring',
            title: '版权监测',
            name: 'ganan_copyrightMonitoring',
            component: () => import('@/viewsGangAn/copyrightServices/copyrightMonitoring/index.vue')
        },
        {
            path: '/gananCopyrightMonitoringUp',
            title: '版权监测',
            name: 'ganan_copyrightMonitoringUp',
            component: () => import('@/viewsGangAn/copyrightServices/copyrightMonitoring/copyrightMonitoringUp.vue')
        },
        {
            path: '/gananCopyrightRights',
            title: '版权维权',
            name: 'ganan_copyrightRights',
            component: () => import('@/viewsGangAn/copyrightServices/copyrightRights/index.vue')
        },
        {
            path: '/gananAboutUs',
            title: '关于我们',
            name: 'ganan_aboutUs',
            redirect: "/gananAboutUs/gansu",
            component: () => import('@/viewsGangAn/aboutUs/index.vue'),
            children: [
                {
                    path: 'gansu',
                    name: 'ganan_gansu',
                    component: () => import('@/viewsGangAn/aboutUs/gansu.vue')
                },
                {
                    path: 'gangan',
                    name: 'ganan_gangan',
                    component: () => import('@/viewsGangAn/aboutUs/gangan.vue')
                },
                {
                    path: 'ganganjieshao',
                    name: 'ganan_ganganjieshao',
                    component: () => import('@/viewsGangAn/aboutUs/ganganjieshao.vue')
                }
            ]
            
        },
        {
            path: '/gananNewCenter',
            title: '新闻资讯',
            name: 'ganan_newCenters',
            component: () => import('@/viewsGangAn/newCenter/index.vue'),
            children: [
                {
                    path: 'indexList',
                    name: 'ganan_indexList',
                    component: () => import('@/viewsGangAn/newCenter/indexList.vue')
                },
                {
                    path: 'newDetails',
                    name: 'ganan_newDetails',
                    component: () => import('@/viewsGangAn/newCenter/newDetails.vue')
                },
            ]
        },
        {
            path: '/gananAnswer',
            title: '版权问答',
            name: 'ganan_answer',
            component: () => import('@/viewsGangAn/answer/index.vue'),
            redirect: '/gananAnswer/wenist',
            children: [
                {
                    path: 'wenist',
                    name: 'ganan_wenist',
                    component: () => import('@/viewsGangAn/answer/wenist.vue')
                },
                {
                    path: 'mywenList',
                    name: 'ganan_mywenList',
                    component: () => import('@/viewsGangAn/answer/mywenList.vue')
                },
                {
                    path: 'wenDetails',
                    name: 'ganan_wenDetails',
                    component: () => import('@/viewsGangAn/answer/wenDetails.vue')
                },
            ]
        },
        {
            path: '/gananNewCenterNewDetails',
            title: '新闻资讯',
            name: 'ganan_newDetails',
            component: () => import('@/viewsGangAn/newCenter/newDetails2.vue')
        },
        {
            path: '/gananAuthenticationCenter',
            title: '验证中心',
            name: 'ganan_authenticationCenter',
            component: () => import('@/viewsGangAn/authenticationCenter/index.vue')
        },
        {
            path: '/gananCertificateQuery',
            title: '证书查询',
            name: 'ganan_certificateQuery',
            component: () => import('@/viewsGangAn/authenticationCenter/certificateQuery.vue')
        },
        {
            path: '/gananIpAuth',
            title: 'IP授权',
            name: 'ganan_ipAuth',
            component: () => import('@/viewsGangAn/ipAuth/index.vue')
        },
        {
            path: '/gananIPlist',
            title: 'IP授权',
            name: 'ganan_IPlist',
            component: () => import('@/viewsGangAn/ipAuth/IPlist.vue')
        },
        {
            path: '/gananProjectList',
            title: 'IP授权',
            name: 'ganan_projectList',
            component: () => import('@/viewsGangAn/ipAuth/projectList.vue')
        },
        {
            path: '/gananProjectList2',
            title: 'IP授权',
            name: 'ganan_projectList2',
            component: () => import('@/viewsGangAn/ipAuth/projectList2.vue')
        },
        {
            path: '/gananprojectListThree',
            title: 'IP授权',
            name: 'ganan_projectListThree',
            component: () => import('@/viewsGangAn/ipAuth/projectListThree.vue')
        },
        {
            path: '/gananSpecial',
            title: 'IP授权',
            name: 'ganan_special',
            component: () => import('@/viewsGangAn/ipAuth/special.vue')
        },
        {
            path: '/gananApplyEquity',
            title: 'IP授权',
            name: 'ganan_applyEquity',
            component: () => import('@/viewsGangAn/ipAuth/applyEquity.vue')
        },
        {
            path: '/gananIPinfo',
            title: 'IP授权',
            name: 'ganan_IPinfo',
            component: () => import('@/viewsGangAn/ipAuth/IPinfo.vue')
        },
        {
            path: 'IPLicenseDetails',
            title: '授权详情',
            name: 'IPLicenseDetails',
            component: () => import('@/views/vipClip/user/service/IPLicenseDetails.vue')
        },
        {
            path: 'IPLicenseFile',
            title: '相关文件',
            name: 'IPLicenseFile',
            component: () => import('@/views/vipClip/user/service/IPLicenseFile.vue')
        },
        // 2021-11-9 end
        {
            path: '/instrument/:id',
            title: '法律服务',
            name: 'instrument',
            component: () => import('@/views/vipClip/firstPage/instrument.vue')
        },
        {
            path: 'ownspace',
            title: '个人中心',
            name: 'ownspace_index',
            component: () => import('@/views/own-space/own-space.vue')
        },
        {
            path: 'change-pass',
            title: '修改密码',
            name: 'change_pass',
            component: () => import('@/views/change-pass/change-pass.vue')
        },
        {path: 'message', title: '消息中心', name: 'message_index', component: () => import('@/views/message/message.vue')},
        {
            path: 'add',
            title: '添加',
            name: 'add',
            component: () => import('@/views/xboot-vue-template/new-window/add.vue')
        },
        {
            path: 'edit',
            title: '编辑',
            name: 'edit',
            component: () => import('@/views/xboot-vue-template/new-window/edit.vue')
        },
        {
            path: 'message-send-detail',
            title: '消息发送详情',
            name: 'message_send_detail',
            component: () => import('@/views/sys/message-manage/messageSendDetail.vue')
        }
    ]
};
// 作为个人中心的组件展示右侧的路由
export const User = {
    path: '/',
    name: 'User',
    component: () => import('@/views/User.vue'),
    children: [
        {
            path: 'memberInfo',
            title: '会员信息',
            name: 'memberInfo',
            component: () => import('@/views/vipClip/user/personal/member-info.vue')
        },
        {
            path: 'myExisting',
            title: '我的存证',
            name: 'myCert',
            component: () => import('@/views/vipClip/user/service/myCert.vue')
        },
        {
            path: 'mycert_detail',
            title: '我的存证',
            name: 'myCertDetail',
            component: () => import('@/views/vipClip/user/service/mycert_detail.vue')
        },
        // {
        //     path: 'myEvidence',
        //     title: '我的取证',
        //     name: 'myEvidence',
        //     component: () => import('@/views/vipClip/user/service/myEvidence.vue')
        // },
        {
            path: 'evidenceAndTort',
            title: '我的取证',
            name: 'evidenceAndTort',
            component: () => import('@/views/vipClip/user/service/evidenceAndTort.vue')
        },
        {
            path: 'IPLicense',
            title: 'IP授权',
            name: 'IPLicense',
            component: () => import('@/views/vipClip/user/service/IPLicense.vue')
        },
        // {
        //     path: 'myTort',
        //     title: '侵权取证订单',
        //     name: 'myTort',
        //     component: () => import('@/views/vipClip/user/service/myTort.vue')
        // },
        {
            path: 'myNotarization',
            title: '我的确认函',
            name: 'myNotarization',
            component: () => import('@/views/vipClip/user/service/myNotarization.vue')
        },
        {
            path: 'myInsurance',
            title: '我的保险',
            name: 'myInsurance',
            component: () => import('@/views/vipClip/insurance/myInsurance.vue')
        },
        {
            path: 'myDci',
            title: '我的登记',
            name: 'myDci',
            component: () => import('@/views/vipClip/user/service/myDci.vue')
        },
		// {
		//     path: 'myDciOrder',
		//     title: '附加服务列表',
		//     name: 'myDciOrder',
		//     component: () => import('@/views/vipClip/user/service/myDci-order.vue')
		// },
        {
            path: 'mySoft',
            title: '软著登记',
            name: 'mySoft',
            component: () => import('@/views/vipClip/user/service/mySoft.vue')
        },
        {
            path: 'legalOrder',
            title: '法律服务列表',
            name: 'legalOrder',
            component: () => import('@/views/vipClip/user/service/legal-order.vue')
        },
        {
            path: 'MyDaftar',
            title: '我的登记',
            name: 'MyDaftar',
            component: () => import('@/views/vipClip/user/service/MyDaftar.vue')
        },
        {
            path: 'myMonitor',
            title: '我的监测',
            name: 'myMonitor',
            component: () => import('@/views/vipClip/user/service/myMonitor.vue')
        },
        {
            path: 'walletPackage',
            title: '我的钱包',
            name: 'wallet',
            component: () => import('@/views/vipClip/user/personal/wallet.vue')
        },
        {
            path: 'history',
            title: '登录历史',
            name: 'history',
            component: () => import('@/views/vipClip/user/more/history.vue')
        },
        {
            path: 'bill',
            title: '我的发票',
            name: 'bill',
            component: () => import('@/views/vipClip/user/more/bill.vue')
        },
        {
            path: 'obligee',
            title: '作者管理',
            name: 'obligee',
            component: () => import('@/views/vipClip/user/more/obligee/obligee.vue')
        },
        {
            path: 'gangAnxiangqin',
            title: '作者详情',
            name: 'gangAnxiangqin',
            component: () => import('@/views/vipClip/user/more/obligee/gangAnxiangqin.vue')
        },
        {
            path: 'gangAnxiangqin2',
            title: '作者详情',
            name: 'gangAnxiangqin2',
            component: () => import('@/views/vipClip/user/more/obligee/gangAnxiangqin2.vue')
        },
        {
            path: 'addObligee',
            title: '增加作者',
            name: 'addObligee',
            component: () => import('@/views/vipClip/user/more/obligee/addObligee.vue')
        },
        {
            path: 'addEnterpriseObligee',
            title: '增加企业作者',
            name: 'addEnterpriseObligee',
            component: () => import('@/views/vipClip/user/more/obligee/addEnterpriseObligee.vue')
        },
        {
            path: 'addPersonalObligee',
            title: '增加个人作者',
            name: 'addPersonalObligee',
            component: () => import('@/views/vipClip/user/more/obligee/addPersonalObligee.vue')
        },

        {
            path: 'legalOrderDetails',
            title: '服务记录',
            name: 'legalOrderDetails',
            component: () => import('@/views/vipClip/user/service/legal-order-details.vue')
        },
        {
            path: 'messages',
            title: '消息通知',
            name: 'message',
            component: () => import('@/views/vipClip/user/more/message.vue')
        },
        {
            path: 'inviteFriend',
            title: '邀请有好礼',
            name: 'invite',
            component: () => import('@/views/vipClip/user/more/invite.vue')
        },
        {
            path: 'authentication',
            title: '实名认证',
            name: 'authentication',
            component: () => import('@/views/vipClip/user/more/authentication/authentication.vue')
        },
        {
            path: 'personalAuthentication',
            title: '个人实名',
            name: 'personalAuthentication',
            component: () => import('@/views/vipClip/user/more/authentication/personalAuthentication.vue')
        },
        {
            path: 'enterpriseAuthentication1',
            title: '企业实名',
            name: 'enterpriseAuthentication1',
            component: () => import('@/views/vipClip/user/more/authentication/enterpriseAuthentication1.vue')
        },
        {
            path: 'enterpriseAuthentication2',
            title: '企业法人信息',
            name: 'enterpriseAuthentication2',
            component: () => import('@/views/vipClip/user/more/authentication/enterpriseAuthentication2.vue')
        },
        {
            path: 'look-member',
            title: '会员权益',
            name: 'lookMember',
            component: () => import('@/views/vipClip/user/personal/lookMember.vue')
        },
        {
            path: 'gift',
            title: '活动权益',
            name: 'gift',
            component: () => import('@/views/newActivity/gift.vue')
        },
        {
            path: 'coupon',
            title: '我的优惠券',
            name: 'coupon',
            component: () => import('@/views/vipClip/coupon/coupon.vue')
        },
        {
            path: 'myOrder',
            title: '我的订单',
            name: 'MyOrder',
            component: () => import('@/views/vipClip/coupon/myOrder.vue')
        },
    ]
}

// 活动页

// export const newActivity = {path: '/huodong.html', name: 'activity', component: () => import('@/views/newActivity/activity.vue')};
export const reddots = {path: '/huodong/libao.html', name: 'reddots', component: () => import('@/views/newActivity/reddot.vue')};
// export const gift = {path: '/gift', name: 'gift', component: () => import('@/views/newActivity/gift.vue')};

export const appRouter = [];

// 所有上面定义的路由都要写在下面的routers里
export const routers = [
    loginRouter,
    registRouter,
    registResult,
    otherRouter,
    locking,
    ...appRouter,
    page404,
    page500,
    page403,
    consultationList,
    consultationInfo,
    onlineAnswers,
    searchQuestion,
    certList,
    certInfo,
    evidenceList,
    evidenceInfo,
    copyrightEvidence,
    User,
    vipOne,
    vipTwo,
    vipSeven,
    lawContract,
    lawInfringing,
    lawIssue,
    lawJudgement,
    lawService,
    lawTelephone,
    evidence,
    evidenceWeb,
    monitor,
    monitorIntroduce,
    insurance,
    openVip,
    orderPay,
    aboutUs,
    copyrightRegList,
    copyrightCert,
    copyrightDetails,
    copyrightSuccess,
    // copyrightLogin,
    applyCert,
    copyrightRegistration,
    copyrightRegistrationBHBJ,
    copyrightRegistrationYuDengji,
    creationVerification,
    monitoring,
    monitorDetails,
    verificationCode,
    verificationCenter,
    ganAnVerificationCenter, // 港安
    contentListOriginal,
    verificationPublic,
    certVerify,
    dciIntroduce,
    invitePage,
    thirdLogin,
    channelCooperation,
    // newActivity,
    reddots,
    // gift,
    //活动中心
    activity,
    //活动中心详情页
    // activityDetail
    evdenceActivity,
    tortInfo,
    //vip 介绍页
    vipIntroduce,
    //定制订单
    madeOrder,
    //公证详情
    notarizationDetails,
    //短视频详情
    videoDetail,
    notarizationDetails,
    //三证活动
    // threeSyndromesActivity,
    //活动登记
    copyrightRegistrationActivity,
    //版权登记查询
    // copyrightRegistrationSearch,
    //城市合伙人
    partnershipPlan,
    //双12活动
    // doubleTwelve
    // 春节红包活动
    // springFestival,
	//知识产权日活动
    // zhishichanquanri,
    //springFestival,
    // 我的优惠券
    // coupon
	// answer,
    // answerQust,
    // answerQustion
];
